import React, { useState, useEffect, useRef } from "react";
import { SummaryChart } from "../charts/SummaryChart";
import { TodoItemDate } from "../common/TodoItemDate";
import { GiClover } from "react-icons/gi";
import { BiLineChart } from "react-icons/bi";
import {
	getSummaryData,
	getIconForCode,
} from "../../services/summaryReportsService";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { ChartContainerMessage } from "./ChartContainerMessage";

export const SummaryChartContainer = ({ code }) => {
	const [data, setData] = useState([]);
	const [hasErrored, setHasErrored] = useState(false);
	const [def, setDef] = useState(null);

	const mounted = useRef(false);

	useEffect(() => {
		mounted.current = true;

		getSummaryData(code)
			.then((responseData) => {
				if (mounted.current === true) {
					setData(responseData.data);
					setDef(responseData.def);
				}
			})
			.catch((e) => {
				if (mounted.current === true) {
					setHasErrored(true);
				}
			});

		return () => {
			mounted.current = false;
		};
	}, []);

	if (hasErrored === true) {
		return (
			<ChartContainerMessage
				message={"There is no information to display for this period"}
			/>
		);
	}

	if (data.length === 0 || def === null) {
		return <LoadingSpinner />;
	}

	if (!data.lastReport) {
		return (
			<ChartContainerMessage
				message={"There is no information to display for this period"}
			/>
		);
	}

	return (
		<div className={"h-full flex flex-col"}>
			<div
				className={"flex items-center justify-center pt-1 pb-3 sm:pt-6 sm:pb-8"}
			>
				{!!data.lastReport ? (
					<>
						<span
							className={
								"text-center text-gray-600 text-xs sm:text-sm pl-1 flex-grow-0"
							}
						>
							Your last report was due on &nbsp;
						</span>
					</>
				) : (
					<span
						className={
							"text-center text-gray-600 text-xs sm:text-sm pl-1 flex-grow-0"
						}
					>
						There is no information to display for this period
					</span>
				)}
				{data.lastReport && <TodoItemDate epoch={data.lastReport ?? null} />}
			</div>
			<SummaryChart code={code} data={data} def={def} />
		</div>
	);
};
